import { FilesUploader } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { Controller, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, Input, MultipleMediaFilesPicker } from "ui";

import { DriverCertificateFormAtomProps } from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

const CertificateField = ({
  control,
  certificate
}: DriverCertificateFormAtomProps) => {
  const { t } = useTranslation();

  const {
    fields: mediaFiles,
    append: appendMediaFile,
    remove: removeMediaFile
  } = useFieldArray({
    control,
    name: `${certificate.name}.images`
  });

  return (
    <div className={styles.driverForm__block}>
      <h4 className={styles.driverForm__block__title}>
        {t(certificate.label)}
      </h4>
      <div className={styles.driverForm__certificateInputs}>
        <Controller
          control={control}
          name={`${certificate.name}.reference`}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value}
              onChange={onChange}
              label={`${t(certificate.label)} ${t("Number")}`}
              errorMessage={error?.message}
              data-testid="driver--licenseNumber"
              maxLength={25}
            />
          )}
        />

        <div className={styles.driverForm__verticalLine} />

        <Controller
          control={control}
          name={`${certificate.name}.images`}
          render={({ fieldState: { error } }) => (
            <FormField
              label={`${t(certificate.label)} ${t("Photo")}`}
              errorMessage={error?.message}
            >
              <FilesUploader
                onSuccessUploading={appendMediaFile}
                uploadDirectoryKey={MediaDirectoryKeys.InventoryManager}
              >
                {(uploaderProps) => (
                  <MultipleMediaFilesPicker
                    allowedMediaTypes={[MediaType.IMAGE, MediaType.DOCUMENT]}
                    size="md"
                    {...uploaderProps}
                    value={mediaFiles}
                    onDeleteMediaFile={removeMediaFile}
                  />
                )}
              </FilesUploader>
            </FormField>
          )}
        />
      </div>
    </div>
  );
};

export default CertificateField;
